import { TrendingUp, PieChart } from "lucide-react";
import { T } from "@/i18n";

export const Improvements = ({ items = [], score = 0 }) => {
  const total = items.reduce((s, i) => s + (Number(i.points) || 0), 0);
  return (
    <div data-testid="improvement-tips-card" className="print-break rounded-3xl bg-emerald-50 p-8 md:p-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-700"><TrendingUp className="h-4 w-4" /><T>Come migliorare il tuo TS Impact Score</T></p>
          <h3 className="mt-2 font-display text-2xl font-semibold text-gray-900"><T>Come fare ancora meglio nel tuo prossimo viaggio</T></h3>
        </div>
        <p data-testid="tis-potential" className="rounded-full bg-white px-4 py-2 text-sm font-semibold text-emerald-800 ring-1 ring-emerald-200">
          <T n={Math.min(100, score + total)}>{"Potenziale: {n} / 100"}</T>
        </p>
      </div>
      <div className="mt-8 grid gap-4 md:grid-cols-2">
        {items.map((t, i) => (
          <div key={i} data-testid={`improvement-tip-${i}`} className="flex gap-4 rounded-2xl bg-white p-5 transition-transform hover:-translate-y-0.5">
            <span className="h-fit shrink-0 rounded-full bg-emerald-600 px-3 py-1 font-display text-sm font-bold text-white">+{t.points}</span>
            <div>
              <p className="font-semibold text-gray-900">{t.title}</p>
              <p className="mt-1 text-sm leading-relaxed text-gray-600">{t.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const BudgetSplit = ({ items = [] }) => items.length > 0 && (
  <div data-testid="budget-split-card" className="print-break rounded-3xl border border-emerald-100 bg-white p-8">
    <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-700"><PieChart className="h-4 w-4" /><T>Ripartizione indicativa del budget</T></p>
    <div className="mt-6 divide-y divide-gray-100">
      {items.map((b, i) => (
        <div key={i} data-testid={`budget-split-${i}`} className="grid grid-cols-[1fr_auto] gap-x-4 py-3">
          <p className="font-medium text-gray-900">{b.category}</p>
          <p className="font-display font-semibold text-emerald-700">{b.share}</p>
          <p className="col-span-2 text-sm text-gray-500">{b.tip}</p>
        </div>
      ))}
    </div>
    <p className="mt-4 text-xs text-gray-400"><T>Stime percentuali, non prezzi reali.</T></p>
  </div>
);
